// extracted by mini-css-extract-plugin
export default {"title":"styles__title___TXdxb","small":"styles__small___iEc7U","medium":"styles__medium___L0uq2"};